// export const formatCnpj = (cnpj: string) => {
//   return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
// }

// export const anonCnpj = (cnpj: string): string => {
//   /* Show only 3 firsts and 3 lasts characters */
//   /* Replace the others to '*' */
//   const firstThree = cnpj.slice(0, 4);
//   const lastThree = cnpj.slice(-3);
//   const middle = cnpj.slice(4, -3);
//   const regexSelectNumbers = /\d/g;
//   const anonMiddle = middle.replaceAll(regexSelectNumbers, '*');
//   return firstThree + anonMiddle + lastThree;

// }

// export const numericCnpj = (cnpj: string): string => {
//   const numericCnpj = cnpj.replace(/\D/g, '')

//   return numericCnpj
// }

export const formatCnpj = (cnpj: string): string => {
  // Remove qualquer formatação existente primeiro
  const raw = cnpj.replace(/[./-]/g, '');
  
  // Verifica se é o novo formato alfanumérico (contém letras)
  if (/[A-Za-z]/.test(raw)) {
    // Formato alfanumérico: XX.XXX.XXX/XXXX-XX (mas com letras)
    // Exemplo: MQ.LH0.CKO/0001-89
    const match = raw.match(/^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})$/);
    if (match) {
      return `${match[1]}.${match[2]}.${match[3]}/${match[4]}-${match[5]}`;
    }
    return cnpj; // Retorna original se não conseguir formatar
  }
  
  // Formato numérico antigo
  const numeric = cnpj.replace(/\D/g, '');
  return numeric.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export const anonCnpj = (cnpj: string): string => {
  // Remove formatação para trabalhar com o conteúdo bruto
  const raw = cnpj.replace(/[./-]/g, '');
  
  // Tamanho total esperado: 14 caracteres (ambos os formatos)
  if (raw.length !== 14) return cnpj;
  
  // Novo formato alfanumérico (contém letras)
  if (/[A-Za-z]/.test(raw)) {
    const firstFour = raw.slice(0, 4);      // Primeiros 4 chars
    const lastThree = raw.slice(-3);        // Últimos 3 chars
    const middle = raw.slice(4, -3);        // Meio (7 chars)
    
    // Substitui QUALQUER caractere do meio por '*'
    const anonMiddle = middle.replace(/./g, '*');
    
    return firstFour + anonMiddle + lastThree;
  }
  
  // Formato numérico antigo
  const firstThree = raw.slice(0, 4);
  const lastThree = raw.slice(-3);
  const middle = raw.slice(4, -3);
  const anonMiddle = middle.replace(/\d/g, '*');
  
  return firstThree + anonMiddle + lastThree;
}

export const numericCnpj = (cnpj: string): string => {
  // Remove formatação básica
  const raw = cnpj.replace(/[./-]/g, '');
  
  // Verifica se é alfanumérico
  if (/[A-Za-z]/.test(raw)) {
     return raw;
  }
  
  // Para CNPJ antigo, remove tudo que não é dígito
  return cnpj.replace(/\D/g, '');
}

// Função adicional útil: validar se é um CNPJ (antigo ou novo)
export const isValidCnpjFormat = (cnpj: string): boolean => {
  const raw = cnpj.replace(/[./-]/g, '');
  
  // Ambos os formatos devem ter 14 caracteres
  if (raw.length !== 14) return false;
  
  // Pode ser:
  // 1. Totalmente numérico (antigo) - opcionalmente validar dígitos verificadores
  // 2. Alfanumérico com pelo menos uma letra (novo)
  const isNumeric = /^\d+$/.test(raw);
  const isAlphanumeric = /^[A-Za-z0-9]+$/.test(raw) && /[A-Za-z]/.test(raw);
  
  return isNumeric || isAlphanumeric;
}